import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';

const gc = new DisposalSet();

registerFragment('chroa-person-modal', (fragmentEl) => {
    const isEditMode = document.body.classList.contains('has-edit-mode-menu');
    const dialog = fragmentEl.querySelector('.chroa-person-modal') as HTMLDialogElement;

    if (!dialog || isEditMode) return;

    const closeBtn = dialog.querySelector('.chroa-person-modal__close-btn') as HTMLButtonElement;

    closeBtn?.addEventListener('click', (event: Event) => {
        event.preventDefault();
        event.stopPropagation();
        dialog.close();
    });

    dialog.addEventListener('click', (event: MouseEvent) => {
        const rect = dialog.getBoundingClientRect();
        const isInDialog = (
            rect.top <= event.clientY &&
            event.clientY <= rect.bottom &&
            rect.left <= event.clientX &&
            event.clientX <= rect.right
        );

        if (!isInDialog) {
            dialog.close();
        }
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
